import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducer';
import { selectAppDirection } from 'src/app/@store/app.selectors';

@Component({
  selector: 'error-dialog',
  templateUrl: './error-dialog.component.html',
  styles: ['.dialog { min-width: 255px; }'],
})
export class ErrorDialogComponent implements OnInit {
  public data: any;

  constructor(
    public config: DynamicDialogConfig,
    private readonly translate: TranslateService,
    private readonly store: Store<AppState>,
    private cdRef: ChangeDetectorRef,
  ) {
    this.data = config.data;
    this.config.header = this.translate.instant('ERROR_DIALOG.TITLE');
  }

  ngOnInit() {
    this.store.select(selectAppDirection).subscribe((direction) => {
      this.config.style = { direction };
      this.cdRef.detectChanges();
    });
  }
}
